import React from 'react';

import { Tooltip } from '@/components/Tooltip';
import {
  statusBadgeVariants,
  type StatusChipVariant,
} from '@/components/ui/badge';
import { cn } from '@/lib/utils';

export type { StatusChipVariant }; // re-export for ergonomic consumer imports

export interface StatusChipProps {
  label: string;
  variant?: StatusChipVariant;
  icon?: React.ReactNode;
  tooltip?: string;
  className?: string;
}

export const StatusChip: React.FC<StatusChipProps> = ({
  label,
  variant = 'default',
  icon,
  tooltip,
  className,
}) => {
  const chip = (
    <div
      className={cn(
        statusBadgeVariants({ variant }),
        icon && 'gap-1.5',
        className
      )}
    >
      {icon && <span className="size-3 shrink-0">{icon}</span>}
      <span className="truncate">{label}</span>
    </div>
  );

  return tooltip ? <Tooltip title={tooltip}>{chip}</Tooltip> : chip;
};
